export default __webpack_public_path__ + "72b820fe66c4bd8ff6ca14042b387dc0.jpg";